
<!-- 结果页 -->
<template>
  <div class="result">
    <div class="header">
      <img @click="pushHome" alt src="@/assets/img/h5/left.png" />
      <div class="titles" v-if="answerData.examinationName">{{answerData.examinationName}}</div>
    </div>
    <div class="my_Body" v-if="customerExaminationTestLogEntity">
      <div class="title">
        <span v-if="customerExaminationTestLogEntity.correctRate >= 95">太赞了，基本都正确了呢！</span>
        <span v-else-if="customerExaminationTestLogEntity.correctRate >= 60">太棒了，完成的还不错哦！</span>
        <span v-else>本次答题不够理想。加油哦！</span>
      </div>
      <div class="img">
        <img
          src="@/assets/img/h5/newQuestiongoldmedal@2x.png"
          v-if="customerExaminationTestLogEntity.correctRate >= 95"
        />
        <img
          src="@/assets/img/h5/newQuestionsilvermedal@2x.png"
          v-else-if="customerExaminationTestLogEntity.correctRate >= 60"
        />
        <img src="@/assets/img/h5/newQuestionbronzemedal@2x.png" v-else />
      </div>
      <div class="Accuracy">本次答题正确率为：{{customerExaminationTestLogEntity.correctRate}} %</div>
      <div
        class="time"
        v-if="initData.typeId != 2"
      >本次答题耗时： {{getDuration(customerExaminationTestLogEntity.useTime)}}</div>
      <div class="bank">
        <div>正确：{{customerExaminationTestLogEntity.trueCount}}题</div>
        <div>错误：{{customerExaminationTestLogEntity.falseCount}}题</div>
        <div>不计分：{{customerExaminationTestLogEntity.noScore}}题</div>
      </div>
      <div class="alt_text">错题已收录值错题本，简答题不计分。</div>
      <div @click="goParsing(0)" class="viewResult btn">查看答题结果</div>
      <div @click="goParsing(1)" class="viewWarning btn">查看错题</div>
      <div @click="againAnswer" class="againAnswer btn">重新答题</div>
    </div>
    <ParsingSheet
      :activeindex="page_index"
      :bankdata="   active_type ==0? dataAll : warningAndTruedataAll"
      :isanwers="true"
      :istrues="istrue"
      :numcount="0"
      v-if="dataAll && dataAll.length > 0"
      v-on:getstatus="getstatus"
      v-on:getvalue="getvalue"
    ></ParsingSheet>
  </div>
</template>

<script>
import ParsingSheet from '@/components/h5/questionBank/ParsingSheet.vue'
import * as QUESTION_API from '@/api/ExaminationAPI'
import * as dateUtil from '@/api/dateUtil'
export default {
  components: {
    ParsingSheet
  },
  data () {
    return {
      answerData: '',
      customerExaminationTestLogEntity: {},
      token: '',
      initData: '',
      baseUrl: sessionStorage.getItem('base_url') || '',
      loading: false,
      dataAll: '',
      istrue: false,
      page_index: '',
      home: 0,//0 回到课程列表  1 回上一级
    };
  },
  computed: {},
  watch: {},
  created () {
    if (this.$route.params.data) {
      this.answerData = this.$route.params
    } else {
      this.answerData = JSON.parse(sessionStorage.getItem('resultPage')) || ''
    }
    console.log('xx', this.answerData)
    this.home = this.answerData.home || 0
    this.getCustomerExaminationResult()
  },
  mounted () {

  },
  destroyed () { }, //生命周期 - 销毁完成
  //方法集合
  methods: {

    //时间转换
    getDuration (val) {
      if (val) {
        return dateUtil.getDuration(val)
      }
    },
    //查询考试结果
    getCustomerExaminationResult () {
      const loading = this.$loading({
        text: '数据加载中……'
      });
      let data = {
        customerExaminationTestLogId: this.answerData.customerExaminationTestLogId
      }
      QUESTION_API.getCustomerExaminationResult(data).then(res => {
        loading.close();
        if (res && Number(res.code) === 0) {
          this.customerExaminationTestLogEntity = res.data
          console.log(this.customerExaminationTestLogEntity)
        } else {
          this.$message.warning(res.msg)
        }
      }).catch(err => {
        loading.close();
        console.log(err)
      })
    },


    // 错误跳转
    errorHtml: function (msg) {
      sessionStorage.setItem('error', msg)
      location.href = sessionStorage.getItem('href') + 'error.html'
    },
    pushHome () {
      if (this.home > 0) {
        this.$router.back()
      } else {
        if (sessionStorage.getItem('isChannel')) {
          this.$router.push({
            path: '/h5/CourseDetail',
            query: {
              token: localStorage.getItem('shangke_token'),
              c_no: localStorage.getItem('c_no'),
              cat_id: localStorage.getItem('cat_id'),
              show_header: localStorage.getItem('show_header'),
              show_data: localStorage.getItem('show_data')
            }
          })
        } else {
          this.$router.push('/h5/CourseDetail')
        }
      }
    },

    // 跳转页面
    goParsing: function (type) {
      if (type == 1) {
        this.$router.push({
          name: 'ParsingPage',
          params: { answerData: this.answerData }
        })
        sessionStorage.setItem('parsingPage', JSON.stringify(this.answerData))
      } else {
        this.$router.push({
          name: 'ParsingPage',
          params: { answerData: this.answerData, istrue: !this.istrue },
        })
        sessionStorage.setItem('parsingPage', JSON.stringify(this.answerData))
      }
    },
    // 跳转页面  重新考试
    againAnswer () {
      let data = {
        examination: this.answerData,
        actionType: 1 //开始答题
      }
      setTimeout(() => {
        this.$router.push(
          {
            name: 'AnswerPage',
            params: data
          }
        )
        sessionStorage.setItem('answerPage', JSON.stringify(data))
      }, 200)
    },
    // 关闭弹窗
    getstatus (val) {
      this.istrue = val
    },
  },
}
</script>
<style scoped>
.result {
  margin: 0.5rem;
}

.header {
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: bold;
  padding-bottom: 0.84375rem;
  border-bottom: 1px solid #eeeeee;
}
.header img {
  width: 1.2rem;
}
.header .titles {
  width: 91%;
  text-align: center;
  font-size: 1.2rem;
}
.my_Body {
  width: 100%;
}

.my_Body .title {
  margin-top: 3.40625rem;
  width: 100%;
  text-align: center;
  color: #4da7f9ff;
  font-weight: 600;
}
.my_Body .title span {
  text-align: center;
  width: 100%;
}
.img {
  width: 100%;
  margin: 1.34375rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img img {
  width: 30%;
}
.Accuracy {
  width: 55%;
  font-weight: 600;
  margin: 1rem auto;
}
.time {
  width: 55%;
  margin: 0 auto;
  font-weight: 600;
}
.bank {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8125rem;
  margin: 1.40625rem 0;
  font-weight: 600;
}
.alt_text {
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
  color: #bbbbbb;
  margin: 1.15625rem 0;
}
.btn {
  width: 14.0625rem;
  height: 2.0625rem;
  border-radius: 0.3125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  font-weight: 600;
  margin: 1rem auto;
}
.viewResult {
  background: linear-gradient(
    -3deg,
    rgba(74, 199, 255, 1),
    rgba(77, 167, 249, 1)
  );
  color: #fff;
}
.viewWarning {
  background: #e0f2ffff;
  color: #4da7f9ff;
}
.againAnswer {
  background: rgba(238, 238, 238, 1);
}
</style>











